import HeroSection from "./components/HeroSection";
import RankingSection from "./components/RankingSection";
import ComparisonTable from "./components/ComparisonTable";
import DetailSection from "./components/DetailSection";
import HowToSection from "./components/HowToSection";
import FaqSection from "./components/FaqSection";
import FooterSection from "./components/FooterSection";

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <HeroSection />
      <RankingSection />
      <ComparisonTable />
      <DetailSection />
      <HowToSection />
      <FaqSection />
      <FooterSection />
    </div>
  );
}